module.exports = __webpack_public_path__ + "img/logo.9ce14415.png";